import useMutateApi from "../useMutateApi"
import axios from "axios"

// constants
import apiEndpoints from "api/utils/apiEndpoints"
import { REFRESH_TOKEN_KEY } from "constants/appState.js"

// utils
import getUrl from "api/apiMap"
import { getCookie } from "api/apiUtils"

const axiosPublic = axios.create({})

export const usePostResetUserPassword = () => {
  return useMutateApi({
    method: "post",
    apiEndpoint: getUrl(apiEndpoints.resetPassword),
    invalidateQueries: [],
    successMsg: "Successfully reset password",
  })
}

export const postLogin = (payload) => {
  return axiosPublic.post(getUrl(apiEndpoints.login), payload)
}

export const postForgotPassword = (payload) => {
  return axiosPublic.post(getUrl(apiEndpoints.forgotPassword), payload)
}

export const postResetPasswordWithToken = (payload) => {
  return axiosPublic.post(getUrl(apiEndpoints.resetLoginPassword), payload)
}

export const postResetPasswordWithTokenAndOldPassword = (payload, token) => {
  return axiosPublic.post(getUrl(apiEndpoints.resetPassword), payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      credentials: "include",
      "Cache-Control": "no-store, no-cache, must-revalidate, max-age=0",
    },
  })
}

export const postLogout = () => {
  return axios.post(getUrl(apiEndpoints.logout), { refresh: getCookie(REFRESH_TOKEN_KEY) })
}
